// import { useState } from "react";
// import Html from "../assets/svg/html-1.svg";
// import Css from "../assets/svg/css-3.svg";
import Javascript from "../assets/svg/javascript.svg";
import Typescript from "../assets/svg/typescript-2.svg";
import ReactLogo from "../assets/svg/react-2.svg";
import Next from "../assets/svg/next-js.svg";
import Tailwind from "../assets/svg/tailwindcss.svg";
import Nodejs from "../assets/svg/nodejs.svg";
import Mongodb from "../assets/svg/mongodb-icon-1.svg";
import Vue from "../assets/svg/vue.svg";
import Nestjs from "../assets/svg/nestjs.svg";
import Docker from "../assets/svg/docker.svg";

export const stack = [
    {
      name: "javascript",
      img: Javascript,
    },
    {
      name: "typescript",
      img: Typescript,
    },
    {
      name: "tailwind",
      img: Tailwind,
    },
    {
      name: "react",
      img: ReactLogo,
    },
    {
      name: "vue",
      img: Vue,
    },
    {
      name: "next",
      img: Next,
    },
    {
      name: "node",
      img: Nodejs,
    },
    {
      name: "nestjs",
      img: Nestjs,
    },
    {
      name: "mongodb",
      img: Mongodb,
    },
    {
      name: "docker",
      img: Docker,
    }
  ];